import type { ImplementationTypology } from '@gozoki/api-types'

const STORE_TYPOLOGY_LABELS: Record<string, string> = {
  HYPERCENTER: 'Hypercentre',
  CENTRE: 'Centre-ville',
  ZA_COMMERCIAL: 'Zone commerciale',
  ZA_INDUSTRIEL: 'Zone industrielle',
  ZA_TERTIAIRE: 'Zone tertiaire',
} satisfies Record<ImplementationTypology, string>

export const storeTypologyLabel = (code: string): string => STORE_TYPOLOGY_LABELS[code] ?? code
